import JSZip from "jszip";

export async function handleZippedTextFiles(data, callback) {
  let zipData;
  
  // Handle either base64 encoded data from server or direct Blob from file upload
  if (data.zipFile) {
    // If a direct Blob/File was provided (user upload)
    zipData = data.zipFile;
  } else if (typeof data === 'object' && data.sessionData) {
    // If base64 encoded data was provided from server
    const byteCharacters = atob(data.sessionData);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    zipData = new Uint8Array(byteNumbers);
  } else if (typeof data === 'string') {
    // Legacy support for direct base64 string
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    zipData = new Uint8Array(byteNumbers);
  } else {
    console.error('Invalid data format for zip handling');
    return;
  }

  const zip = new JSZip();

  try {
    const content = await zip.loadAsync(zipData);
    const processPromises = [];
    
    content.forEach((relativePath, file) => {
      if (!file.dir) {
        processPromises.push(
          file.async('text').then(fileData => {
            return callback({relativePath, fileData});
          })
        );
      }
    });
    
    // Wait for all files to be processed
    await Promise.all(processPromises);
    
  } catch (err) {
    console.error('Error reading zip file:', err);
  }
}
